// SPDX-License-Identifier: BUSL-1.1

/**
 * External tool links for the dashboard footer.
 *
 * Configured via VITE_* env vars at build time. Links with no value
 * are filtered out, so operators can set only the ones they use.
 *
 */

export interface ExternalLink {
  label: string;
  href: string;
}

export const EXTERNAL_LINKS: ExternalLink[] = [
  { label: 'PostHog',     href: (import.meta.env.VITE_POSTHOG_URL       as string | undefined) ?? '' },
  { label: 'Sentry',      href: (import.meta.env.VITE_SENTRY_URL        as string | undefined) ?? '' },
  { label: 'PlanetScale', href: (import.meta.env.VITE_DB_CONSOLE_URL    as string | undefined) ?? '' },
  { label: 'Upstash',     href: (import.meta.env.VITE_CACHE_CONSOLE_URL as string | undefined) ?? '' },
  { label: 'NocoDB',      href: (import.meta.env.VITE_NOCODB_URL        as string | undefined) ?? '' },
].filter((l) => l.href.length > 0);
